import { render } from "./feedback-error.vue?vue&type=template&id=1224b7c4"
import script from "./feedback-error.vue?vue&type=script&lang=js"
export * from "./feedback-error.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__